import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { DetailedUserWithStats } from "@/user/user.d";

export const RankingCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "👑",
  accessorFn: (_, index) => index + 1,
  size: 48,
  minSize: 48,
  maxSize: 48,
  enableSorting: false,
  cell: ({ getValue }) => (
    <Stack className="pl-1.5" fullWidth>
      {getValue() as number}
    </Stack>
  ),
});
